/* eslint-disable no-undef */
import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Alert, AlertTitle, Button, FormControl, Select, MenuItem, Typography, Box, useTheme, TextField } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { LoadingButton } from "@mui/lab";
import Checkbox from "@mui/material/Checkbox";
import Vector from "../../../../../assets/images/Vector.svg";
import insta from "../../../../../assets/images/insta.svg";
import linkedin from "../../../../../assets/images/linkedin.svg";
import fb from "../../../../../assets/images/fb.svg";
import DragAndDropInput from "../../../../../components/DragAndDropInput";
import CustomInput from "../../../../../components/CustomInput";
import { useForm } from "../../../../../hooks/useForm";
import { AddNewEmployeeData, SPECIAL_PROJECTS } from "../../../../../constants/data";
import { AddNewEmployeeValidation } from "../../../../../helper/Validation";
import styles from "./style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import DocumentUpload from "../../../../../components/DocumentUpload";
import { nationalities } from "../Edit/data";
import color from "../../../../../constants/color";
import { useFormContext } from "../../../../../context/FormContext";

const AddNewEmployeePage = ({ registerEmployee, loading, handleUrl, handleMultipleUrl, CountryCode, departmentData, operatorData, departmentLoaded, operatorLoaded, document, setDocument, payslip, userData, projectList }) => {
  const [mobile, setMobile] = useState("")
  const [emergency, setEmergency] = useState("")
  const [workplace, setWorkplace] = useState("")
  const { formData, setFormData } = useFormContext();
  const [cCode, setCCode] = useState("")
  const [emergencyCode, setEmergencyCode] = useState("")
  const [workplaceCode, setWorkplaceCode] = useState("")

  const mobileNumberRef = useRef(null);
  const options = countryList().getData();
  const theme = useTheme();
  const navigate = useNavigate();
  const [docs1, setDocs1] = useState([{ name: "", url: "", }]);

  const [selectedPosition, setSelectedPosition] = useState("");
  const [sameAsPhysical, setSameAsPhysical] = useState(false);

  useEffect(() => {
    const existingProject = formData?.projects?.[0];
    if (existingProject) {
      const name = typeof existingProject === "string" ? existingProject : existingProject?.name;
      if (name) setSelectedPosition(name);
    }
  }, [JSON.stringify(formData?.projects)]);

  const onRegister = (formData) => {
    const data = {
      ...formData,
      projects: {
        value: selectedPosition
          ? [{ name: selectedPosition, status: "active" }]
          : []
      }
    };

    registerEmployee(
      data,
      mobile,
      cCode,
      emergency,
      emergencyCode,
      workplace,
      workplaceCode
    );
  };
  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    AddNewEmployeeData,
    AddNewEmployeeValidation,
    onRegister
  );
  const {
    firstName, nickName, lastName, gender, empType, password, confirmPassword, jobPosition, department, address1, address2, city, zipCode, country,
    email, dob, education, salary, nationality, restraintTrade, profileImg, payfreq, paymentType, rateRembTravel, religion, marital,
    passportNum, hourlyRate, bankName, accountNum, ifscCode, accountHolder, personalTaxCode, joiningDate, start, end,
    experience, taskNoti, urlSkype, urlLinkedin, urlInsta, isExtraTime, isOvertime,
    isDoubleOverTime, isTracked, accountType, urlFb, isActive, rate, extraTimeRate, doubleOverTimeRate, idNumber,
    taxRefNo,
    medicalAidNo,
    operator,
    } = state;

  const handleSyncedChange = (name, value, other) => {
    handleChange(name, value, other);

    if (name === "passportNum") {
      handleChange("idNumber", value);
    } else if (name === "idNumber") {
      handleChange("passportNum", value);
    } else if (name === "personalTaxCode") {
      handleChange("taxRefNo", value);
    } else if (name === "taxRefNo") {
      handleChange("personalTaxCode", value);
    } else if (name === "address1" && sameAsPhysical) {
      handleChange("address2", value);
    }
  };

  const handleSameAsPhysicalChange = (e) => {
    const checked = e.target.checked;
    setSameAsPhysical(checked);
    if (checked) {
      handleChange("address2", address1.value || formData?.personalInfo?.addressLine1 || "");
    }
  };

  const handleNavigateBack = () => {
    navigate("/dashboard/manageStaff")
  }

  // Check if all required fields are filled
  const isFormValid = () => {
    // Personal Information required fields
    const personalInfoValid = 
      (firstName.value || formData?.personalInfo?.firstName) &&
      (lastName.value || formData?.personalInfo?.surName) &&
      (dob.value || formData?.personalInfo?.dob) &&
      (nationality.value || formData?.otherInformation?.nationality) &&
      (passportNum.value || formData?.otherInformation?.passportNo) &&
      (gender.value || formData?.personalInfo?.gender) &&
      mobile &&
      password.value &&
      confirmPassword.value &&
      (jobPosition.value || formData?.personalInfo?.jobPosition?.[0]) &&
      (department.value || formData?.personalInfo?.department) &&
      (country.value || formData?.personalInfo?.country) &&
      (city.value || formData?.personalInfo?.city) &&
      (address1.value || formData?.personalInfo?.addressLine1) &&
      (address2.value || formData?.personalInfo?.addressLine2) &&
      (zipCode.value || formData?.personalInfo?.zipCode) &&
      (email.value || formData?.personalInfo?.email) &&
      (operator.value || formData?.personalInfo?.operator) &&
      (education.value || formData?.personalInfo?.education);

    // Salary Information required fields
    const salaryInfoValid = 
      (salary.value || formData?.salaryInfo?.salary) &&
      (hourlyRate.value || formData?.salaryInfo?.hRate) &&
      (payfreq.value || formData?.salaryInfo?.payfreq) &&
      (paymentType.value || formData?.personalInfo?.paymentType);

    // Bank Information required fields
    const bankInfoValid = 
      (accountHolder.value || formData?.bankInfo?.accountHolder) &&
      (accountNum.value || formData?.bankInfo?.account) &&
      (ifscCode.value || formData?.bankInfo?.bankCode) &&
      (bankName.value || formData?.bankInfo?.bank) &&
      (accountType.value || formData?.bankInfo?.acType);

    // Experience required fields
    const experienceValid = 
      (joiningDate.value || formData?.experience?.joiningDate) &&
      (experience.value || formData?.experience?.exp);

    // Employee Type required fields
    const empTypeValid = 
      (empType.value || formData?.additionalInformation?.empType);

    // Tax Information required fields (Tax Ref. No is optional)
    const taxInfoValid =
      (idNumber.value || formData?.taxInfo?.idNumber);

    return personalInfoValid && salaryInfoValid && bankInfoValid && experienceValid && empTypeValid && taxInfoValid;
  };

  useEffect(() => {
    if (window.intlTelInputGlobals) {
      window.intlTelInputGlobals.loadUtils("build/js/utils.js");
    }
  }, []);


  const handleOnChanges = (value, country) => {
    setMobile(value);
    setCCode(country?.dialCode)
  };

  const handleEmergencyOnChanges = (value, country) => {
    setEmergency(value);
    setEmergencyCode(country?.dialCode)
  };

  const handleWorkplaceOnChanges = (value, country) => {
    setWorkplace(value);
    setWorkplaceCode(country?.dialCode)
  };


  const handleAddDoc = () => {
    setDocs1([...docs1, { name: "", url: "" }]);
    setDocument([...document, { name: "", url: "" }])
  };
  const handleDeleteDoc = (index) => {
    const updatedDoc = [...docs1];
    const updatedDocument = [...document];
    updatedDoc.splice(index, 1);
    setDocs1(updatedDoc);
    updatedDocument.splice(index, 1);
    setDocument(updatedDocument);
  };
  const handleDocChange = (value, index, key) => {
    setDocument((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index] = { ...updatedItems[index], [key]: value };
      return updatedItems;
    });
  };

  // Required dropdowns whose options come from company setup. Only flag a list
  // once it has loaded successfully, so a slow or failed fetch is not reported as "empty".
  const missingSetup = [
    departmentLoaded && !departmentData?.length && "Department (Account Settings → Additional Information → Department Type)",
    operatorLoaded && !operatorData?.length && "Role Type (Account Settings → Additional Information → Role Type)",
  ].filter(Boolean);

  return (
    <Box sx={{ pl: 2 }}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Box sx={styles.mainGrid}>
          <Typography sx={styles.headTitle} variant="h4">
            New Employee
          </Typography>
        </Box>

        {missingSetup.length > 0 && (
          <Alert severity="warning" variant="outlined" sx={styles.setupAlert}>
            <AlertTitle>Setup required before adding an employee</AlertTitle>
            The following required fields have no options yet. Please configure them first:
            <Box component="ul" sx={styles.setupAlertList}>
              {missingSetup.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </Box>
          </Alert>
        )}

        <Grid container display="flex" flexDirection="row">
          <Grid item lg={6} sm={12}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>
                Personal Informations
              </Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}> First Name <span style={{ color: "red" }}>*</span> </Typography>
                    <CustomInput
                      name="firstName"
                      value={firstName.value}
                      defaultValue={formData?.personalInfo?.firstName}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={firstName.error}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}> Surname <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="lastName"
                      value={lastName.value}
                      defaultValue={formData?.personalInfo?.surName}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={lastName.error}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}> Nick Name </Typography>
                    <CustomInput
                      name="nickName"
                      value={nickName.value}
                      defaultValue={formData?.personalInfo?.nickName}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={nickName.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} >

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Typography sx={styles.textsize}>Date Of Birth <span style={{ color: "red" }}>*</span></Typography>
                      {/* <InputLabel sx={styles.label}>Date Of Birth</InputLabel> */}
                      <DatePicker

                        value={dob.value ? dayjs(dob.value) : formData?.personalInfo?.dob ? dayjs(formData?.personalInfo?.dob) : null}
                        maxDate={dayjs().subtract(16, "year")}
                        onChange={(newValue) => {
                          handleChange("dob", newValue ? newValue.format("YYYY-MM-DD") : null);
                        }}

                        error={dob.error}
                        sx={styles.dateInput}
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.9em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={styles.textsize}>Nationality<span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={nationality?.value || formData?.otherInformation?.nationality}
                        onChange={(event) => { handleChange("nationality", event.target.value) }}
                        name="nationality"
                        onFocus={handleFocus}
                        sx={styles.dropDownMenu}
                      >
                        {nationalities?.map((item, index) => (
                          <MenuItem key={index} sx={styles.dropDownMenu} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>ID/Pas Number<span style={{ color: "red" }}>*</span> </Typography>
                    <CustomInput
                      fullWidth
                      name="passportNum"
                      value={passportNum.value}
                      defaultValue={formData?.otherInformation?.passportNo}
                      onChange={handleSyncedChange}
                      onFocus={handleFocus}
                      error={passportNum.error}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                          mb: 1
                        },
                      }}
                    >
                      {/* <InputLabel shrink={true}>Gender</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Gender<span style={{ color: "red" }}>*</span> </Typography>

                      <Select
                        value={gender.value || formData?.personalInfo?.gender}
                        onChange={(e) => handleChange("gender", e.target.value)}
                        name="gender"
                        sx={styles.dropDownMenu}
                        onFocus={handleFocus}
                        error={gender.error}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>

                        <MenuItem sx={styles.dropDownMenu} value="male">
                          Male
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="female">
                          Female
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="other">
                          Other
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.mobileGrid} >
                      <Typography shrink={true} sx={styles.textsize}>Mobile <span style={{ color: "red" }}>*</span></Typography>

                      <PhoneInput
                        country={"za"}
                        enableSearch={true}
                        value={mobile}
                        defaultValue={cCode || formData?.personalInfo?.mobile}
                        name="mobile"
                        onChange={(value, country) => handleOnChanges(value, country)}
                        onFocus={handleFocus}
                        ref={mobileNumberRef}
                        error={mobile.error}
                        sx={styles.mobile}
                        inputProps={{
                          style: {
                            height: "1em",
                            borderRadius: "10px",
                          },
                        }}

                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Password <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="password"
                      type="password"
                      value={password.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={password.error}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Confirm Password <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="confirmPassword"
                      type="password"
                      value={confirmPassword.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={confirmPassword.error}
                      matchPassword={password.value}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Job Position <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="jobPosition"
                      value={jobPosition.value}
                      defaultValue={formData?.personalInfo?.jobPosition[0]}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={jobPosition.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px"
                      }
                    }} >
                      {/* <InputLabel shrink={true}>Department</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Department <span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={department.value || formData?.personalInfo?.department}
                        onChange={(event) => { handleChange("department", event.target.value) }}
                        name="department"
                        sx={styles.dropDownMenu}
                        onFocus={handleFocus}
                        error={country.error}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>


                        {departmentData?.map((item, index) => (

                          <MenuItem key={index} sx={styles.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}

                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px"
                      }
                    }} >
                      <Typography shrink={true} sx={styles.textsize}>Role Type <span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={operator?.value || formData?.personalInfo?.operator}
                        onChange={(event) => { handleChange("operator", event.target.value) }}
                        name="operator"
                        sx={styles.dropDownMenu}
                        onFocus={handleFocus}
                        error={operator?.error}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>


                        {operatorData?.map((item, index) => (

                          <MenuItem key={index} sx={styles.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}

                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={{
                      "& .MuiOutlinedInput-root": {
                        height: "2.8em",
                        marginTop: "0.5em",
                        borderRadius: "10px"
                      }
                    }} >
                      {/* <InputLabel shrink={true}>Country</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Country <span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={country.value || formData?.personalInfo?.country}
                        onChange={(event) => { handleChange("country", event.target.value), CountryCode(event.target.value) }}
                        name="country"
                        sx={styles.dropDownMenu}
                        onFocus={handleFocus}
                        error={country.error}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>


                        {options.map((country, index) => (

                          <MenuItem key={index} sx={styles.dropDownMenu} value={country.label}>{country.label}</MenuItem>
                        ))}

                      </Select>
                    </FormControl>


                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>City <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="city"
                      value={city.value}
                      onChange={handleChange}
                      defaultValue={formData?.personalInfo?.city}
                      onFocus={handleFocus}
                      error={city.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Physical Address <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="address1"
                      value={address1.value}
                      onChange={handleSyncedChange}
                      onFocus={handleFocus}
                      defaultValue={formData?.personalInfo?.addressLine1}
                      error={address1.error}
                      multiline
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Postal Address <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="address2"
                      value={address2.value}
                      defaultValue={formData?.personalInfo?.addressLine2}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={address2.error}
                      disabled={sameAsPhysical}
                      multiline
                    />
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          checked={sameAsPhysical}
                          onChange={handleSameAsPhysicalChange}
                        />
                      }
                      label="Postal address same as physical address"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Zip Code <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="zipCode"
                      type="Number"
                      inputmode="numeric"
                      value={zipCode.value}
                      defaultValue={formData?.personalInfo?.zipCode}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={zipCode.error}
                    />
                  </Grid>


                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}> Email<span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="email"
                      value={email.value}
                      defaultValue={formData?.personalInfo?.email}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={email.error}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}> Education <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="education"
                      value={education.value}
                      defaultValue={formData?.personalInfo?.education}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={education.error}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}> Employee Id <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      name="empNumber"
                      value={empNumber.value}
                      defaultValue={formData?.empId}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={empNumber.error}
                    />
                  </Grid> */}

                  <Grid item xs={12}>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox
                          checked={isActive?.value ?? true} />
                      }
                      onChange={(e) =>
                        handleChange("isActive", e.target.checked)
                      }
                      label="Is Active"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        color: theme.palette.lightGray.dark,
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      Upload Profile Image
                    </Typography>
                    <DragAndDropInput
                      profileImg={profileImg}
                      handleUrl={handleUrl}
                    />
                  </Grid>

                </Grid>
              </Grid>
            </Grid>

            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Additional Options</Typography>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1} sx={{ display: "block" }}>
                  {/* <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox defaultChecked={profileVisibility?.value} />
                      }
                      onChange={(e) =>
                        handleChange("profileVisibility", e.target.checked)
                      }
                      label="Profile Visibility For Everyone"
                    />
                  </Grid> */}
                  {/* <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={
                        <Checkbox defaultChecked={isPreAttendance?.value} />
                      }
                      onChange={(e) =>
                        handleChange("isPreAttendance", e.target.checked)
                      }
                      label="Access For Editing Previous Attendance"
                    />
                  </Grid> */}
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={<Checkbox defaultChecked={taskNoti?.value} />}
                      onChange={(e) =>
                        handleChange("taskNoti", e.target.checked)
                      }
                      label="New Task Notifications"
                    />
                  </Grid>
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={<Checkbox defaultChecked={isTracked?.value} />}
                      onChange={(e) =>
                        handleChange("isTracked", e.target.checked)
                      }
                      label="Is Tracked"
                    />
                  </Grid>
                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={<Checkbox defaultChecked={isOvertime?.value} />}
                      onChange={(e) =>
                        handleChange("isOvertime", e.target.checked)
                      }
                      label="Allow OverTime"
                    />
                  </Grid>
                  {isOvertime?.value && (
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>eg Rate x 1.5 </Typography>
                      <CustomInput
                        fullWidth
                        name="rate"
                        placeholder={"0.0"}
                        value={rate?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error=""
                        defaultValue="0"

                      />
                    </Grid>
                  )}

                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={<Checkbox defaultChecked={isExtraTime?.value} />}
                      onChange={(e) =>
                        handleChange("isExtraTime", e.target.checked)
                      }
                      label="Allow ExtraTime"
                    />
                  </Grid>
                  {isExtraTime?.value && (
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>eg Rate x 1.3 </Typography>
                      <CustomInput
                        fullWidth
                        name="extraTimeRate"
                        placeholder={"0.0"}
                        value={extraTimeRate?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error=""
                        defaultValue="0"

                      />
                    </Grid>
                  )}

                  <Grid>
                    <FormControlLabel
                      sx={styles.formControlLabel}
                      control={<Checkbox defaultChecked={isDoubleOverTime?.value} />}
                      onChange={(e) =>
                        handleChange("isDoubleOverTime", e.target.checked)
                      }
                      label="Allow DoubleOverTime"
                    />
                  </Grid>
                  {isDoubleOverTime?.value && (
                    <Grid item xs={12} sm={6}>
                      <Typography sx={styles.textsize}>eg Rate x 2 </Typography>
                      <CustomInput
                        fullWidth
                        name="doubleOverTimeRate"
                        placeholder={"0.0"}
                        value={doubleOverTimeRate?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error=""
                        defaultValue="0"
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Other Informations</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Religion </Typography>
                    <CustomInput
                      fullWidth
                      name="religion"
                      value={religion.value}
                      defaultValue={formData?.otherInformation?.religion}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={religion.error}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      {/* <InputLabel shrink={true}>Marital</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Marital </Typography>
                      <Select
                        value={marital.value || formData?.otherInformation?.martial}
                        onChange={(e) =>
                          handleChange("marital", e.target.value)
                        }
                        name="Marital"
                        sx={styles.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>

                        <MenuItem sx={styles.dropDownMenu} value="Yes">
                          Yes
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="No">
                          No
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.mobileGrid} >
                      <Typography shrink={true} sx={styles.textsize}>Emergency Contact </Typography>

                      <PhoneInput
                        country={"za"}
                        enableSearch={true}
                        value={emergency}
                        defaultValue={emergencyCode || formData?.otherInformation?.emergencyContact}
                        name="mobile"
                        onChange={(value, country) => handleEmergencyOnChanges(value, country)}
                        onFocus={handleFocus}
                        ref={mobileNumberRef}
                        error={mobile.error}
                        sx={styles.mobile}
                        inputProps={{
                          style: {
                            height: "1em",
                            borderRadius: "10px",
                          },
                        }}

                      />
                    </FormControl>


                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth sx={styles.mobileGrid} >
                      <Typography shrink={true} sx={styles.textsize}>Workplace </Typography>

                      <PhoneInput
                        country={"za"}
                        enableSearch={true}
                        value={workplace}
                        defaultValue={workplaceCode || formData?.otherInformation?.workplace}
                        name="mobile"
                        onChange={(value, country) => handleWorkplaceOnChanges(value, country)}
                        onFocus={handleFocus}
                        ref={mobileNumberRef}
                        error={mobile.error}
                        sx={styles.mobile}
                        inputProps={{
                          style: {
                            height: "1em",
                            borderRadius: "10px",
                          },
                        }}

                      />
                    </FormControl>


                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item lg={6} sm={12}>

            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Salary Informations</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Salary <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      fullWidth
                      name="salary"
                      // type="Number"
                      value={salary.value}
                      onChange={handleChange}
                      defaultValue={formData?.salaryInfo?.salary}
                      onFocus={handleFocus}
                      error={salary.error}
                      inputProps={{ min: "0" }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      {/* <InputLabel shrink={true}>Rate</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Rate <span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={hourlyRate.value || formData?.salaryInfo?.hRate}
                        onChange={(e) =>
                          handleChange("hourlyRate", e.target.value)
                        }
                        name="hourlyRate"
                        onFocus={handleFocus}
                        error={hourlyRate.error}
                        sx={styles.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>

                        <MenuItem sx={styles.dropDownMenu} value="Hourly">Hourly</MenuItem>

                        <MenuItem sx={styles.dropDownMenu} value="Salary">Salary</MenuItem>

                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Restraint Of Trade </Typography>
                    <CustomInput
                      fullWidth
                      name="restraintTrade"
                      // type="Number"
                      value={restraintTrade.value}
                      defaultValue={formData?.salaryInfo?.restraintTrade}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={restraintTrade.error}
                    />
                  </Grid>


                  <Grid item xs={12} sm={6}>

                    <FormControl fullWidth sx={styles.formControl}>

                      {/* <InputLabel shrink={true}>Pay Frequency</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Pay Frequency <span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={payfreq.value || formData?.salaryInfo?.payfreq}
                        onChange={(e) =>
                          handleChange("payfreq", e.target.value)
                        }
                        name="payfreq"
                        sx={styles.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>

                        <MenuItem sx={styles.dropDownMenu} value="Monthly">
                          Monthly
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Weekly">
                          Weekly
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Fortnight">
                          Fortnight
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Custom">
                          Custom
                        </MenuItem>


                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>

                    <FormControl fullWidth sx={styles.formControl}>

                      {/* <InputLabel shrink={true}>Payment Type</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Payment Type <span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={paymentType.value || formData?.personalInfo?.paymentType}
                        onChange={(e) =>
                          handleChange("paymentType", e.target.value)
                        }
                        name="paymentType"
                        sx={styles.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>

                        <MenuItem sx={styles.dropDownMenu} value="Cash">
                          Cash
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Cheque">
                          Cheque
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="Transfer">
                          Transfer
                        </MenuItem>

                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography sx={styles.textsize}>Rate Per Kilometre On Reimbursive Travel</Typography>
                    <CustomInput
                      fullWidth
                      name="rateRembTravel"
                      // type="Number"
                      value={rateRembTravel.value}
                      defaultValue={formData?.salaryInfo?.rateRembTravel}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={rateRembTravel.error}
                    />
                  </Grid>


                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Bank Informations</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Account Holder <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      fullWidth
                      name="accountHolder"
                      value={accountHolder.value}
                      onChange={handleChange}
                      defaultValue={formData?.bankInfo?.accountHolder}
                      onFocus={handleFocus}
                      error={accountHolder.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Account No. <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      fullWidth
                      name="accountNum"
                      value={accountNum.value}
                      defaultValue={formData?.bankInfo?.account}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={accountNum.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      {country?.value === "India"
                        ? "IFSC"
                        : "Branch Code"}<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="ifscCode"
                      value={ifscCode.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      defaultValue={formData?.bankInfo?.bankCode}
                      error={ifscCode.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Bank Name <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      fullWidth
                      name="bankName"
                      value={bankName.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={bankName.error}
                      defaultValue={formData?.bankInfo?.bank}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Account Type <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      fullWidth
                      name="accountType"
                      value={accountType.value}
                      onChange={handleChange}
                      defaultValue={formData?.bankInfo?.acType}
                      onFocus={handleFocus}
                      error={accountType.error}
                    />
                  </Grid>


                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>
                      {country?.value === "India"
                        ? "GST"
                        : "Personal Income Tax"}
                    </Typography>
                    <CustomInput
                      fullWidth
                      name="personalTaxCode"
                      value={personalTaxCode.value}
                      onChange={handleSyncedChange}
                      defaultValue={formData?.bankInfo?.taxCode}
                      onFocus={handleFocus}
                      error={personalTaxCode.error}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Experience</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} >
                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                      {/* <InputLabel sx={styles.label}>Joining Date</InputLabel> */}
                      <Typography sx={styles.textsize}>Joining Date <span style={{ color: "red" }}>*</span></Typography>

                      <DatePicker
                        fullWidth
                        value={dayjs(joiningDate.value) || dayjs(formData?.experience?.joiningDate)}
                        onChange={(newValue) => {
                          handleChange("joiningDate", newValue ? newValue.format("YYYY-MM-DD") : null);
                        }}
                        sx={styles.dateInput}
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                        }}
                        error={joiningDate?.error}
                      />

                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} sm={6} >
                    <Typography sx={styles.textsize}>Total Years Of Experience <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      fullWidth
                      name="experience"
                      value={experience.value}
                      onChange={handleChange}
                      defaultValue={formData?.experience?.exp}
                      onFocus={handleFocus}
                      sx={styles.YearsInput}
                      error={experience.error}

                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Employee Type</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} ms={10}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                          mb: 1,
                        },
                      }}
                    >
                      {/* <InputLabel shrink={true}>Choose Employee Type</InputLabel> */}
                      <Typography shrink={true} sx={styles.textsize}>Choose Employee Type <span style={{ color: "red" }}>*</span></Typography>

                      <Select
                        value={empType.value || formData?.additionalInformation?.empType}
                        onChange={(e) => handleChange("empType", e.target.value)}
                        name="empType"
                        sx={styles.dropDownMenu}
                        onFocus={handleFocus}
                        error={empType.error}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>

                        <MenuItem sx={styles.dropDownMenu} value="director">
                          Director
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="employee">
                          Employee
                        </MenuItem>
                        <MenuItem sx={styles.dropDownMenu} value="contractor">
                          Contractor
                        </MenuItem>

                      </Select>
                    </FormControl>

                  </Grid>
                  <Grid item xs={12} sm={6} ms={10}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                          mb: 1,
                        },
                      }}
                    >
                    <Typography shrink={true} sx={styles.textsize}>Position</Typography>
                      <Select
                        fullWidth
                        name="projects"
                        value={selectedPosition}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedPosition(val);
                          handleChange("projects", {
                            value: val ? [{ name: val, status: "active" }] : []
                          });
                        }}
                        sx={styles.dropDownMenu}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return <span style={{ color: "#aaa" }}>Select Position</span>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem value="" disabled style={styles.dropdownMenu}>Select</MenuItem>
                        <MenuItem value="Casual" style={styles.dropdownMenu}>Casual</MenuItem>
                        <MenuItem value="Permanent" style={styles.dropdownMenu}>Permanent</MenuItem>
                        <MenuItem value="Contract" style={styles.dropdownMenu}>Contract</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {empType.value === "contractor" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Typography sx={styles.textsize}>Start</Typography>
                          <DatePicker
                            value={dayjs(start?.value)}
                            defaultValue={dayjs(formData?.additionalInformation?.contractor?.start)}
                            onChange={(newValue) => {
                              handleChange("start", newValue);
                            }}
                            sx={styles.dateInput}
                            slotProps={{
                              field: {
                                readOnly: true,
                              },
                            }}
                          />

                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Typography sx={styles.textsize}>End</Typography>
                          <DatePicker
                            value={dayjs(end?.value)}
                            onChange={(newValue) => {
                              handleChange("end", newValue);
                            }}
                            sx={styles.dateInput}
                            defaultValue={dayjs(formData?.additionalInformation?.contractor?.end)}
                            slotProps={{
                              field: {
                                readOnly: true,
                              },
                            }}
                          />

                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  )}


                </Grid>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.textsize}>Tax Information</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>ID Number <span style={{ color: "red" }}>*</span></Typography>
                    <CustomInput
                      fullWidth
                      name="idNumber"
                      placeholder={"ID Number"}
                      defaultValue={formData?.idNumber?.value}
                      value={idNumber?.value}
                      onChange={handleSyncedChange}
                      onFocus={handleFocus}
                      error={idNumber?.error}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Tax Ref. No</Typography>
                    <CustomInput
                      fullWidth
                      name="taxRefNo"
                      placeholder={"Tax Ref. No"}
                      defaultValue={formData?.taxRefNo?.value}
                      value={taxRefNo?.value}
                      onChange={handleSyncedChange}
                      onFocus={handleFocus}
                      error={taxRefNo?.error}
                    />
                  </Grid>
                  {/* UIF Number field removed as per requirements */}
                  <Grid item xs={12} sm={6}>
                    <Typography sx={styles.textsize}>Medical Aid No</Typography>
                    <CustomInput
                      fullWidth
                      name="medicalAidNo"
                      placeholder={"Medical Aid No"}
                      defaultValue={formData?.medicalAidNo?.value}
                      value={medicalAidNo?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={medicalAidNo?.error}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Documents</Typography>
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>

                <Grid container spacing={2} sx={{ display: "flex-wrap" }}>
                  {docs1?.map((item, index) => (
                    <>
                      <Grid item xs={4.5} key={index}>
                        <DocumentUpload
                          name="url"
                          handleUrl={(file) => {
                            setDocs1([...docs1, file]);
                          }}
                          docs={docs1}
                          setDocs={setDocs1}
                          value={docs1}
                          handleimage={(val) => { handleMultipleUrl(val, index) }}
                          onChange={(e) => handleDocChange(e.target.value, index, "url")}
                        />
                        <Box>
                          <TextField sx={{ py: "0px" }} name="name" placeholder="File Name" value={document[index]?.name} onChange={(e) => { handleDocChange(e.target.value, index, "name") }}></TextField>
                        </Box>
                      </Grid>
                      <Grid item xs={2} lg={1.5} sx={styles.secondGrid}>
                        <Box sx={styles.btnGridAction}>

                          {index !== 0 && (
                            <Box
                              sx={styles.deleteIcons}
                              onClick={() => handleDeleteDoc(index)}
                            >
                              <DeleteOutlineIcon />
                            </Box>
                          )}
                          {index === 0 && (
                            <Box sx={styles.addIcons} onClick={handleAddDoc}>
                              +
                            </Box>
                          )}

                        </Box>
                      </Grid>
                    </>
                  ))}
                </Grid>

                <Box>
                </Box>
              </Grid>
            </Grid>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              ml="2%"
              mt="2%"
              mb="2%"
            >
              <Box
                sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
              ></Box>
              <Typography sx={styles.subTitle}>Social Media</Typography>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12} sx={styles.card}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside}>Paste Url Skype</Typography>
                    <Box display="flex">
                      <img
                        src={Vector}
                        alt="Skype"
                        style={{ marginRight: "5%" }}
                      />
                      <CustomInput
                        name="urlSkype"
                        value={urlSkype.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        defaultValue={formData?.socialMedia?.skype}
                        error={urlSkype.error}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside}>Paste Url LinkedIn</Typography>
                    <Box display="flex">
                      <img
                        src={linkedin}
                        alt="linkedIn"
                        style={{ marginRight: "3%" }}
                      />
                      <CustomInput
                        name="urlLinkedin"
                        value={urlLinkedin.value}
                        defaultValue={formData?.socialMedia?.linkedIn}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={urlLinkedin.error}
                        sx={{ borderRadius: "30px", ml: 2 }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside}>Paste Url Instagram</Typography>
                    <Box display="flex">
                      <img
                        src={insta}
                        alt="insta"
                        style={{ marginRight: "3%" }}
                      />
                      <CustomInput
                        name="urlInsta"
                        value={urlInsta.value}
                        onChange={handleChange}
                        defaultValue={formData?.socialMedia?.instagram}
                        onFocus={handleFocus}
                        error={urlInsta.error}
                        sx={{ borderRadius: "30px", ml: 2 }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <Typography sx={styles.textside}>Paste Url Facebook</Typography>
                    <Box display="flex">
                      <img src={fb} alt="fb" style={{ marginRight: "3%" }} />

                      <CustomInput
                        name="urlFb"
                        value={urlFb.value}
                        onChange={handleChange}
                        defaultValue={formData?.socialMedia?.facebook}
                        onFocus={handleFocus}
                        error={urlFb.error}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box pb="5%">
          <LoadingButton
            loading={loading}
            variant="contained"
            type="submit"
            color="primary"
            sx={styles.submitButton}
            disabled={!isFormValid()}
          >
            Save As New
          </LoadingButton>

          {userData && (
            <Button
              variant="contained"
              type="submit"
              color="success"
              sx={{
                borderRadius: 50,
                textTransform: "none",
                backgroundColor: color.secondary,
                ml: 2,
              }}
              onClick={() => {
                navigate("/dashboard/additionalInfo", { state: { userData } })
                setFormData(userData)
              }}
            >
              Additional Informations
            </Button>
          )}

          <Button
            variant="contained"
            color="success"
            sx={{
              borderRadius: 50,
              textTransform: "none",
              backgroundColor: "#878787",
              ml: 2,
            }}
            onClick={() => handleNavigateBack()}
          >
            Cancel
          </Button>
        </Box>
      </form>



    </Box>
  );
};

export default AddNewEmployeePage;
